/**
 * Formatters for the representative view-models. These surfaces (Margin, Capacity,
 * Reconciliation) have no backend yet, so they render synthetic, non-client numbers
 * behind an honest "representative — pending backend" chip. gbpK matches the design's
 * £k→£M rollup; values below carry thousands.
 */

export const gbpK = (v: number): string =>
  Math.abs(v) >= 1000 ? `£${(v / 1000).toFixed(2)}M` : `£${Math.round(v)}k`

export const pct = (v: number): string => `${v.toFixed(1)}%`
